<template>
  <div
    class="purchase-button-container"
  >
    <div class="purchase-button" @click="purchase" :class="getClass">
      <span class="purchase-button-text">{{ $bus.transify['FESTA_PURCHASE'] }}</span>
    </div>
    <div class="purchase-button-light" :class="getLightClass"></div>
  </div>
</template>

<script>
import { addGA } from '@/utils/assist'

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    id: Number,
    bought: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getClass () {
      return [
        this.disabled ? 'purchase-button-disabled' : 'purchase-button-enabled'
      ]
    },
    getLightClass () {
      return {
        [`purchase-button-light-${this.$bus.shopType}`]: this.$bus[`inuse${this.$bus.shopType}`]
      }
    }
  },
  methods: {
    purchase () {
      addGA(`purchase-${this.id ? this.id : ''}`, 'click')
      if (!this.disabled) {
        this.$emit('purchase')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.purchase-button-container {
  position: relative;
  @include px2res(width, 178);
  @include px2res(height, 71);

  .purchase-button {
    @include flexrc;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    &.purchase-button-enabled {
      /* @include px2res(-webkit-text-stroke-width, 2);
      -webkit-text-stroke-color: #eff039; */
    }

    .purchase-button-text {
      @include px2res(margin-top, -8);
      font-family: $main-font-family;
      font-weight: 300;
      @include px2res(font-size, 34);
      /* color: $purchase-button-color; */
      color: #fff;
      filter: drop-shadow(1px 0px 0px #4a250f) drop-shadow(-1px 0px 0px #4a250f)
        drop-shadow(0px 1px 0px #4a250f) drop-shadow(0px -1px 0px #4a250f)
        drop-shadow(1px 0px 0px #0b5b9e) drop-shadow(-1px 0px 0px #0b5b9e)
        drop-shadow(0px 1px 0px #0b5b9e) drop-shadow(0px -1px 0px #0b5b9e);
    }
  }

  .purchase-button-light {
    position: absolute;
    @include px2res(top, -17);
    @include px2res(left, -17);
    @include px2res(width, 212);
    @include px2res(height, 108);
    z-index: -1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/business-base/purchase-button/index.vue